import { render } from "./InstallWizardLayout.vue?vue&type=template&id=88c4981e&scoped=true"
import script from "./InstallWizardLayout.vue?vue&type=script&lang=js"
export * from "./InstallWizardLayout.vue?vue&type=script&lang=js"

import "./InstallWizardLayout.vue?vue&type=style&index=0&id=88c4981e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88c4981e"]])

export default __exports__